<template>
  <div class="day">
    <span
      v-if="currentDate"
      :class="{'highlights-yellow': highlightsYellow, 'highlights-gray': highlightsGray}"
      class="date">{{ currentDate.date() }}</span>
    <div class="dots">
      <div
        v-if="showGreenDot"
        class="dot green-dot"/>
      <div
        v-if="showOrangeDot"
        class="dot orange-dot"/>
      <div
        v-if="showRedDot"
        class="dot red-dot"/>
      <div
        v-if="showBlackDot"
        class="dot black-dot"/>
      <div
        v-if="!showBlackDot && !showGreenDot && !showOrangeDot && !showRedDot"
        class="dot"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalendarDay',
  components: {},
  props: {
    currentDate: {
      type: Object,
      default: null,
    },
    highlightsYellow: {
      type: Boolean,
      default: false,
    },
    highlightsGray: {
      type: Boolean,
      default: false,
    },
    showBlackDot: {
      type: Boolean,
      default: false,
    },
    showGreenDot: {
      type: Boolean,
      default: false,
    },
    showOrangeDot: {
      type: Boolean,
      default: false,
    },
    showRedDot: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.date {
  display: inline-block;
  width: 37px;
  height: 37px;
  padding-top: 3px;
}
.highlights-yellow,
.highlights-gray {
  border-radius: 50%;
}
.highlights-yellow {
  background-color: $secondary !important;
}
.highlights-gray {
  background-color: $gray-400;
}
.dots {
  display: flex;
  justify-content: center;
}
.dot {
  height: 6px;
  width: 6px;
  border-radius: 50%;
  margin: 0 2px 0 2px;
}
.black-dot {
  background-color: black;
}
.green-dot {
  background-color: green;
}
.orange-dot {
  background-color: orange;
}
.red-dot {
  background-color: red;
}
</style>
